/**
 * ============================================================================
 * DizyPro ERP
 * Module : Service CRM
 * Feature: Installed Products
 *
 * File:
 * src/modules/service_crm/installed_products/constants/customerTypeMaster.js
 *
 * Description:
 * Customer Type master data used by Installed Product Management.
 *
 * NOTE:
 * These are frontend static masters.
 * Later they will be replaced by Master APIs.
 * ============================================================================
 */

/* ============================================================================
 * CUSTOMER TYPES
 * ========================================================================== */

export const CUSTOMER_TYPES = [
    { value: "", label: "Select" },
    { value: "AGRICULTURE", label: "Agriculture" },
    { value: "HEALTHCARE", label: "Healthcare" },
    { value: "INDUSTRY", label: "Industry" },
    { value: "INFRASTRUCTURE_PROJECTS", label: "Infrastructure & Projects" },
    { value: "MANUFACTURING_GAS", label: "Manufacturing & Gas" },
    { value: "POWERCAR", label: "Powercar" },
    { value: "REAL_ESTATE", label: "Real Estate" },
    { value: "REALTY_HOSPITALITY", label: "Realty and Hospitality" },
    { value: "RETAIL", label: "Retail" },
    { value: "SERVICE", label: "Service" },
    { value: "TELECOM", label: "Telecom" },
    { value: "RENTAL", label: "Rental" },
    { value: "OTHER", label: "Other" },
    { value: "NA", label: "NA" }
];